module.exports = __webpack_public_path__ + "img/tensores.da7a8b09.jpg";